import { SET_SCREEN_SIZE, RESTORE_UPDATE } from '../lib/screenSizeActions';

// Initial State
export const initialState = {
    screenSize: 'desktop',
};

// Reducer
const screenSizeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SCREEN_SIZE:
            return {
                ...state,
                screenSize: action.payload,
            };
        case RESTORE_UPDATE:
            return {
                ...state,
                ...action.state,
            };
        default:
            return state;
    }
};

export {
    screenSizeReducer as default,
    initialState as screenSizeInitialState,
};
